module.exports = __webpack_public_path__ + "img/xls.03324ff2.png";